module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/phone-0ec19343ecfe88212ecfca69e2dc51a7.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/phone.svg
// module id = k34D
// module chunks = 24